import { useCallback } from "react";
import { usePrivy } from "@privy-io/react-auth";
import { useAuthDispatch, userSignOut } from "../AuthContext";
import { clearAccessToken } from "../access-token";
import { useMiniApp } from "./mini-app";
export const useSignOut = () => {
    const dispatch = useAuthDispatch();
    const { isMiniApp } = useMiniApp();
    const { logout } = usePrivy();
    const signOut = useCallback(async () => {
        if (isMiniApp) {
            // TODO: logout from farcaster
        }
        else {
            await logout();
        }
        userSignOut(dispatch);
        clearAccessToken();
    }, [dispatch, isMiniApp, logout]);
    return signOut;
};
